<template>
  <el-menu-item v-if="ifHIde()" :index="item.path" @click="changePage" class="sub-menu-item">
    <template slot="title">
      <span class="el-submenu iconfont font14" :class="renderIcon()" v-if="item.meta.title === '下载中心'">
        {{ item.meta.title }}
        <span v-if="unDownloadCount" class="hint font14">{{ unDownloadCount }}</span>
      </span>
      <span v-else class="el-submenu iconfont icon-yaodianjianguanicon font14" :class="renderIcon()" slot="title">
        {{ item.meta.title }}
      </span>
      <img
        v-if="item.meta.title === '门店账户' && activityAlive"
        class="extra"
        src="@/assets/img/activity/menu-extra.png"
      />
      <!-- <div @click="changePage">
      <img :src="renderImg()" class="icon" alt="" />
      <span v-if="item.meta.title === '咨询列表'">
        {{ item.meta.title }}
      </span>
      <span v-else-if="item.meta.title === '下载中心'">
        {{ item.meta.title }}
        <span v-if="unDownloadCount" class="hint">{{ unDownloadCount }}</span>
      </span>
      <span v-else>
        {{ item.meta.title }}
      </span>
      <img
        v-if="item.meta.title === '门店账户' && activityAlive"
        class="extra"
        src="@/assets/img/activity/menu-extra.png"
      />
    </div> -->
    </template>
  </el-menu-item>
</template>
<script>
import classnames from 'classnames';
import { hasPermission } from '@/util/index';
import { mapState } from 'vuex';
const titleMap = {
  处方列表: 'icon-tubiao-chufangliebiao',
  门店管理: 'icon-tubiao-mendianguanli',
  职员管理: 'icon-tubiao-zhanghaoguanli',
  数据看板: 'icon-tubiao-shujukanban',
  待审处方: 'icon-tubiao-daishenchufang',
  门店账户: 'icon-tubiao-mendianzhanghu',
  服务套餐: 'icon-tubiao-fuwutaocan',
  申请处方: 'icon-tubiao-chufangshenqing',
  咨询列表: 'icon-tubiao-zixunliebiao',
  打卡管理: 'icon-tubiao-dakaguanli',
  企业微信: 'icon-tubiao-qiyeweixin',
  下载中心: 'icon-tubiao-xiazaizhongxi',
  药品管理: 'icon-tubiao-yaopinguanli',
  智云药城: 'icon-tubiao-zhiyunyaocheng',
  智云快药: 'icon-kuaiyaohuiyuanicon'
  // 销售订单: require('@/assets/img/icon_dashboard.png'),
  // 四类药品目录: require('@/assets/img/icon_drug_category.png'), // icon_spec_cate.png
  // 特殊药品目录: require('@/assets/img/icon_spec_cate.png'),
  // 四类药品销售订单: require('@/assets/img/icon_registration_record.png'),
  // 特殊药品销售订单: require('@/assets/img/icon_registration_record.png'),
  // 处方药品销售订单: require('@/assets/img/icon_registration_record.png'),
  // 四类药品登记记录: require('@/assets/img/icon_registration_record.png'),
  // 特殊药品登记记录: require('@/assets/img/icon_registration_record.png'),
  // 处方记录: require('@/assets/img/icon_list.png')
};
export default {
  props: ['item', 'click', 'permissionRoutes'],
  computed: {
    ...mapState('download', ['unDownloadCount']),
    activityAlive() {
      return this.$store.getters.activityAlive;
    }
  },
  methods: {
    renderIcon() {
      // 优化if 改用hash
      return titleMap[this.item.meta.title];
      // 渲染icon
      // if (this.item.meta.title == '处方列表') {
      //   return require('@/assets/img/icon_list.png');
      // }
      // if (this.item.meta.title == '门店管理') {
      //   return require('@/assets/img/icon_shop.png');
      // }
      // if (this.item.meta.title == '职员管理') {
      //   return require('@/assets/img/icon_staff.png');
      // }
      // if (this.item.meta.title == '数据看板') {
      //   return require('@/assets/img/icon_dashboard.png');
      // }
      // if (this.item.meta.title == '待审处方') {
      //   return require('@/assets/img/icon_wait.png');
      // }
      // if (this.item.meta.title == '门店账户') {
      //   return require('@/assets/img/icon_account.png');
      // }
      // if (this.item.meta.title == '申请处方') {
      //   return require('@/assets/img/icon_apply.png');
      // }
      // if (this.item.meta.title == '咨询列表') {
      //   return require('@/assets/img/icon_chat.png');
      // }
      // if (this.item.meta.title == '打卡管理') {
      //   return require('@/assets/img/icon_account.png');
      // }
      // if (this.item.meta.title == '下载中心') {
      //   return require('@/assets/img/icon_account.png');
      // }
    },
    renderActive() {
      // 高亮指定menu
      const route = this.$route;
      const { permissionRoutes } = this;
      const { path, fullPath } = route; // 获取当前路由的全路径
      let itemPath = this.item.path; // 获取该item的路径

      let cls = classnames({
        commonMenuItem: true,
        activeItem: itemPath == route.meta.belong
      });
      return cls;
    },
    ifHIde() {
      // 菜单隐藏逻辑
      let { item } = this;
      try {
        if (item.meta.roles) {
          if (hasPermission(item.meta.roles) == false) {
            // 无权限直接隐藏
            return false;
          }
        }
      } catch (error) {}

      if (item.meta) {
        // 如果meta存在
        if (item.meta.hide) {
          // 如果强制隐藏
          return false;
        }
        if (item.meta.title) {
          // 有title的显示
          return true;
        }
        return true;
      }
      return false;
    },
    changePage() {
      // 页面跳转
      let {
        path,
        meta: { menuClickEventTrackId }
      } = this.item;
      if (menuClickEventTrackId) {
        Telescope.trackEvent({ trackId: menuClickEventTrackId });
      }
      this.$emit('click', path);
    }
  }
};
</script>
<style lang="scss" scoped>
// .commonMenuItem {
//   height: 48px;
//   background: transparent;
//   padding-left: 48px;
//   overflow: hidden;
//   cursor: pointer;
//   opacity: 0.5;
//   span {
//     position: relative;
//     color: #fff;
//     // opacity: 0.5;
//     line-height: 48px;

//     .hint {
//       position: absolute;
//       top: 0;
//       right: -30px;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       width: 16px;
//       height: 16px;
//       font-size: 12px;
//       color: #fff;
//       border-radius: 50%;
//       background-color: #e0514c;
//     }
//   }
//   .icon {
//     display: block;
//     float: left;
//     // width: 22px;
//     // height: 20px;
//     margin-top: 14px;
//     margin-right: 22px;
//     height: 16px;
//     width: 16px;
//   }
//   &:hover {
//     opacity: 1;
//     // span {
//     //   opacity: 1;
//     // }
//   }
//   .extra {
//     margin-top: 16px;
//     width: 64px;
//     float: right;
//     margin-right: 28px;
//   }
// }
// .activeItem {
//   background: #3b3f40;
//   position: relative;
//   opacity: 1;
//   &:after {
//     content: '';
//     height: 100%;
//     background: #1E8DFF;
//     width: 4px;
//     position: absolute;
//     left: 0;
//   }
//   span {
//     opacity: 1;
//     transition: all ease-in-out 400ms;
//   }
// }
.sub-menu-item {
  padding: 0 17px !important;
  position: relative;
}
.font14 {
  font-size: 14px !important;
}
.extra {
  margin-top: 18px;
  width: 64px;
  float: right;
  // margin-right: 28px;
}
.hint {
  position: absolute;
  top: 18px;
  left: 115px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  font-size: 12px;
  color: #fff;
  border-radius: 50%;
  background-color: #e0514c;
}
</style>
